import React, { useState } from 'react';
import ContactForm from './Contact';
import ServiceCards from './Services';
import Faq from './Faq'
import InforServices from './InforServices';
import WhatsAppButton from './Whatsapp';
import { Helmet } from 'react-helmet';
import TitleUpdater from '../../../../utils/TitleUpdater';
import ClientShowcase from './Logoes';
import Industries from './Industries';
import Photoes from './Photoes';
import HomeVideo from './HomeVideo';
import KcsTechInfo from './KcsTechInfo';
import { useRef } from 'react';
import IntroCarousel from './IntroCarousel';
import { Link } from 'react-router-dom';
import webinar from '../../../../Assets/webinar/PTKCS HP.jpg'
import LogoScroll from '../../ResuableComponents/ClientLogoResuable';
import AboutUsInfor from './AboutUsInfor';
import ErpHeroBanner from './ErpHeroBanner';
import Clients from './Clients';
import Portfolio from './Portfolio';
import CTA from './CTA';

const Infor = () => {
  const contact = useRef(null);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "KCS Tech Infor Services",
    "description": "Grow your Business Operations with KCS Tech Infor Consulting Services, Enhance Productivity with Our Expert Infor Managed Services and CloudSuite Solutions.",
    "offers": {
      "@type": "Offer",
      "serviceType": ["Infor Implementation", "ERP Consulting", "Digital Transformation,Enterprise Resource Planning, Human Capital Management, Customer Relationship Management, Industry-Specific Applications, Cloud-Based Solutions, Warehouse Management, Manufacturing Executive System, Workforce Management, Infor Consulting Services"]
    }
  };


  const sampleClients = [
    { name: "GS Battery", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/gs_battery.jpg?updatedAt=1759295406843" },
    // { name: "CRP Group", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/crp_group.png?updatedAt=1759295406585" },
    { name: "HamiltonJet", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/HamiltonJet.jpg?updatedAt=1759295406583" },
    { name: "Chiyaboon", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/chaiyaboon.png?updatedAt=1759295406531" },
    { name: "L&T Defence", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/L%20&%20T%20Defence.jpg?updatedAt=1759295406509" },
    { name: "Vandewiele Savio", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/vandewiele_savio.jpg?updatedAt=1759295405536" },
    { name: "Dreem", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/dreem.jpg?updatedAt=1759295405197" },

    { name: "varley", logo: "https://ik.imagekit.io/satfy9rkc/ptkcs/varley_indonesia_logo.jpg" }
    ,
    { name: "CMR", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/CMR.jpg?updatedAt=1759295406841" },
    { name: "SANDEN", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/sanden.png?updatedAt=1759295406829" },
    { name: "SANOH", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/sanoh.png?updatedAt=1759295406876" },
    { name: "AWAL GULF", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/awal_gulf.jpg?updatedAt=1759295406865" },


    { name: "L&T Defence", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/L%20&%20T%20Defence.jpg?updatedAt=1759295406509" },
    { name: "L&T Defence", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/L%20&%20T%20Defence.jpg?updatedAt=1759295406509" },



  ];

  return (
    <div className="relative">
      <TitleUpdater title="KCS Tech| Infor Consulting Services, LN, M3 & Syteline" />
      {/* SEO OPTIMIZATION */}

      <Helmet>
        {/* Primary Meta Tags */}
        <title>KCS Tech |Infor Consulting Services, LN, M3 & Syteline</title>
        <meta name="title" content="KCS Tech |Infor Consulting Services, LN, M3 & Syteline " />
        <meta name="description" content="Grow your Business Operations with KCS Tech Infor Consulting Services, Enhance Productivity with Our Expert Infor Managed Services and CloudSuite Solutions." />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="KCS Tech Infor Services - Leading Infor Alliance Partner" />
        <meta property="og:description" content="Expert Infor consulting services delivering digital transformation through ERP implementation, integration, and support solutions." />
        <meta property="og:image" content="https://ik.imagekit.io/kqumni8l2/Infor%20Services.jpg?updatedAt=1739434285408" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content="KCS Tech Infor Services - Enterprise ERP Solutions" />
        <meta property="twitter:description" content="Comprehensive Infor consulting services for businesses seeking digital transformation through expert ERP implementation." />
        <meta property="twitter:image" content="https://ik.imagekit.io/kqumni8l2/Infor%20Services.jpg?updatedAt=1739434285408" />

        {/* Additional SEO Meta Tags */}
        <meta name="keywords" content="Infor Consulting Services in Indonesia, Infor ERP Implementation Services, Best Infor Consulting Services in 2025, Why Choose Us Over Other Infor Partners,SAP in Indonesia, SAP services Indonesia, SAP solutions Indonesia,Infor Partner in Indonesia, Infor services Indonesia, Infor solutions Indonesia,
,odoo implementation,odoo erp implementation,odoo implementation company,odoo implementation methodology,odoo implementation partner,odoo implementation steps,odoo implementation services, What Are Infor Consulting Services, Infor ERP Consultants, Infor Implementation Partners, Infor CloudSuite customization, Infor ERP migration, Infor-certified consultants, Infor ERP integration, Infor ERP dashboard optimization, Top Infor Consulting Services for Seamless ERP Implementation, Reduce operational costs by 30% with Infor ERP, Infor-certified consultants, Serving SMEs to Enterprises, ERP Integration Services, Infor CloudSuite Support, Infor ERP for Textile Manufacturing, Infor LN vs. CloudSuite, Infor Consultants Jakarta, Infor ERP Implementation: From Planning to Go-Live, Industries We Serve: Manufacturing, Logistics, Retail, Why 95% of Clients Choose PT KCS for Infor ERP, Recognized by Economic Times, Infor ERP consulting services for small businesses, Best Infor ERP implementation strategies, Affordable Infor ERP consultants, Infor ERP migration services for manufacturers, Infor consulting services for healthcare, Custom Infor ERP solutions for retail, Infor ERP implementation best practices, Infor ERP support services in Indonesia, How to choose an Infor ERP consultant, Infor ERP integration with existing systems, Infor implementation services, Infor ERP consulting, Infor system integration, enterprise resource planning, business process optimization, cloud solutions, ERP service providers, Infor ERP costs, Infor ERP systems, SAP staffing, Oracle services, Aerospace and Defense, Automotive, Construction, Discrete Manufacturing, Distribution, Equipment Service and Rental, Food and Beverage/CPG, General Industry, High Tech and Electronics, Industrial Machinery & Equipment, Industrial Manufacturing, Logistics and 3PL, Retail, Utilities, Enterprise Asset Management, Enterprise Resource Planning, Workforce Management, Infor Construction, Infor LN, Infor Nexus, Intelligent Open Network (ION), ION, ION BI, ION Business Analytics, ION Business Vault, ION Connect, ION Connect 3rd party, ION Enterprise Search, ION Process, ION Pulse, ION Workflow, SCM Transportation Management, Supply Chain Execution, Supply Chain Finance, Supply Chain Management, Supply Chain Planning, Supply Chain Visibility, Supply Management, Infor SyteLine, Infor M3, Warehouse Mobility, Infor CRM, Infor Lawson, Infor Birst (Business Intelligence), Infor Industry Solutions, Infor Healthcare Solutions, Infor Manufacturing Software, Infor Financial Management, Infor Software Market, Infor managed services, Infor federation services, Infor professional services, Infor localization services platform, Infor financial services, Infor data services, Infor m3 web services, Infor web services, Infor visual erp, Infor syteline erp, Infor lawson erp, Infor erp jobs, Infor Accounting Software, Infor LN Software, Infor M3 ERP Software, Banten, Tangerang, Bali, Raya, Green-Office-Park, BSD City," />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="7 days" />
        <meta name="author" content="KCS Tech's Infor Services" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.ptkcs.com/" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>


      <section>
              </section>
      <section>
        <div>

        <div className="w-full lg:h-[90vh]">
          <video
            // src="https://res.cloudinary.com/djaejg3nn/video/upload/v1783424543/DRIVING_BUSINESS_VALUE_WITH_AUTOMATION_CLOUD_TRANSFORMATION_l8gwyy.mp4"
            src="https://res.cloudinary.com/djaejg3nn/video/upload/v1793267918/Intro_KCS_Technologies_kghl0p.mp4"
            className="w-full h-full object-cover"
            autoPlay
            muted
            loop
            playsInline
          />
        </div>
          <Portfolio />
          <Clients />
          {/* <ErpHeroBanner /> */}
          {/* <AboutUsInfor/> */}
        </div>
      </section>


      {/* <section>
        <KcsTechInfo/>
      </section> */}

      <section>
        <InforServices />
      </section>



      {/* <section>
        < WhatsAppButton />
      </section> */}

      <section>
        <Industries />
      </section>

      <section>
        <ServiceCards />
      </section>

      {/* <section>
        <Photoes />
      </section> */}

      {/* <section>
        <Faq />
      </section> */}

      <section>
        <CTA />
      </section>
    </div>
  );
};

export default Infor;



